// Schemas Zod para validação de usuários

import { z } from 'zod';

export const UserRoleSchema = z.enum(['PRODUCAO', 'AGIS', 'FABRICANTE', 'REVENDA']);

export const UserSchema = z.object({
  id: z.string().uuid(),
  nome: z.string().min(2, 'Nome deve ter no mínimo 2 caracteres'),
  email: z.string().email('Email inválido'),
  papel: UserRoleSchema,
  eventId: z.string().uuid().optional(),
  participantId: z.string().uuid().optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime()
});

export const SupabaseUserSchema = UserSchema.extend({
  emailConfirmed: z.boolean().optional(),
  lastSignInAt: z.string().datetime().optional(),
  authId: z.string().uuid().optional()
});

export const LoginRequestSchema = z.object({
  email: z.string().email('Email inválido'),
  password: z.string().min(6, 'Senha deve ter no mínimo 6 caracteres')
});

// Schemas para criação/atualização
export const CreateUserSchema = UserSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateUserSchema = CreateUserSchema.partial();

// Novo: schema enxuto para endpoint de criação (nome, email, papel)
export const UserCreateMinimalSchema = z.object({
  nome: z.string().min(2),
  email: z.string().email(),
  papel: UserRoleSchema
});

// Alteração de papel
export const UserRoleUpdateSchema = z.object({
  papel: UserRoleSchema
});

// Alteração de status (ativar/desativar) - idempotente
export const UserStatusUpdateSchema = z.object({
  ativo: z.boolean()
});

export type UserType = z.infer<typeof UserSchema>;
export type SupabaseUserType = z.infer<typeof SupabaseUserSchema>;
export type LoginRequestType = z.infer<typeof LoginRequestSchema>;
export type CreateUserType = z.infer<typeof CreateUserSchema>;
export type UpdateUserType = z.infer<typeof UpdateUserSchema>;
export type UserCreateMinimalType = z.infer<typeof UserCreateMinimalSchema>;
export type UserRoleUpdateType = z.infer<typeof UserRoleUpdateSchema>;

// Backwards compatibility export in lowerCamelCase expected by server route file
export const userRoleUpdateSchema = UserRoleUpdateSchema;
export type UserStatusUpdateType = z.infer<typeof UserStatusUpdateSchema>;